import DataTableEditableCrud from './DataTableEditableCrud';
export default DataTableEditableCrud;
